<template>
  <div class="chart-container">
    <apexchart 
      :type="chartType"
      :height="chartHeight"
      :options="apexOptions"
      :series="apexSeries"
    />
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'ClientTeusBarChart',
  
  components: {
    apexchart: VueApexCharts
  },
  
  props: {
    chartData: {
      type: Object,
      required: true
    },
    chartHeight: {
      type: Number,
      default: 300
    },
    chartType: {
      type: String,
      default: 'bar'
    }
  },

  computed: {
    apexSeries() {
      if (!this.chartData || !this.chartData.datasets || !this.chartData.datasets[0]) {
        return []
      }
      
      return [{
        name: this.chartData.datasets[0].label || 'TEUs',
        data: this.chartData.datasets[0].data || []
      }]
    },
    
    apexOptions() {
      return {
        chart: {
          type: this.chartType,
          toolbar: {
            show: true,
            tools: {
              download: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true
            }
          }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            distributed: true
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: this.chartData.labels || [],
          labels: {
            rotate: -45,
            style: {
              fontSize: '11px'
            }
          }
        },
        yaxis: {
          title: {
            text: 'Total TEUs'
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + ' TEUs'
            }
          }
        },
        colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#546E7A', '#26a69a', '#D10CE8']
      }
    }
  }
}
</script>

<style scoped>
.chart-container {
  position: relative;
}
</style>




// WEBPACK FOOTER //
// ClientTeusBarChart.vue?391eef64